import React, { memo } from "react";
import styles from "./ReactionPicker.module.scss";

interface ReactionPickerProps {
  onReactionSelect: (reactionIndex: number) => void;
  currentReaction?: number | null;
}

// 8 reaction icons giống module cũ
const REACTIONS = [
  { key: 0, icon: "/icons/favorite.png.png", label: "Favorite" },
  { key: 1, icon: "/icons/love.png.png", label: "Love" },
  { key: 2, icon: "/icons/care.png.png", label: "Care" },
  { key: 3, icon: "/icons/haha.png.png", label: "Haha" },
  { key: 4, icon: "/icons/wow.png.png", label: "Wow" },
  { key: 5, icon: "/icons/sad.png.png", label: "Sad" },
  { key: 6, icon: "/icons/like.png.png", label: "Like" },
  { key: 7, icon: "/icons/done.png.png", label: "Done" },
];

export const ReactionPicker: React.FC<ReactionPickerProps> = ({ onReactionSelect, currentReaction }) => {
  const handleReactionClick = (reactionKey: number) => {
    // Nếu click vào reaction đang chọn, không làm gì
    if (currentReaction === reactionKey) {
      return;
    }

    // Nếu đang không chọn reaction nào mà chọn key 0 (favorite), cũng không làm gì
    if ((currentReaction === null || currentReaction === undefined) && reactionKey === 0) {
      return;
    }
    onReactionSelect(reactionKey);
  };

  return (
    <div className={styles.reactionPicker}>
      {REACTIONS.map((reaction) => (
        <div
          key={reaction.key}
          className={`${styles.reactionButton} ${currentReaction === reaction.key ? styles.active : ""}`}
          onClick={() => handleReactionClick(reaction.key)}
          title={reaction.label}
          style={{
            background: currentReaction === reaction.key ? "#d1cece" : "",
          }}
        >
          <img src={reaction.icon} alt={reaction.label} />
        </div>
      ))}
    </div>
  );
};

export default memo(ReactionPicker);
